import React from "react";
import CategoriesActionsDropdown from "layout/dictionarySearch/CategoriesActionsDropdown";
import PropTypes from "prop-types";

const Header = ({ docsLength }) => {
  return (
    <div className="categories__header" data-testid="categories-header">
      <div className="categories__header__title">
        <div className="categories__header__title-container">
          <span>Documents</span>
        </div>
      </div>
      <div className="categories__header__table_header">
        <span>
          <span className="categories__header__table_header__categories">
            {`Docs (${docsLength})`}
          </span>
          <CategoriesActionsDropdown />
        </span>
        <span>Dictionary</span>
        <span>Size</span>
        <span className="categories__header__table_header__frequency">
          Freq
        </span>
      </div>
    </div>
  );
};

export default Header;

Header.propTypes = {
  docsLength: PropTypes.number,
};
